<template>
  <div>
    <label class="mt-3" for="sb-inline">Quvvati</label>
    <b-form-spinbutton id="sb-inline" v-model="value" inline></b-form-spinbutton>
    <label class="mt-1" for="sb-inline">1-sentabrga ko'ra o'quvchilar holati</label>
    <b-form-spinbutton id="sb-inline" v-model="value" inline></b-form-spinbutton>
    <label class="mt-1" for="sb-inline">Qurilgan yili</label>
    <b-form-spinbutton id="sb-inline" v-model="value" inline></b-form-spinbutton>
    <label class="mt-1" for="sb-inline">Dastur asosida oxirgi marta ta'mirlangani</label>
    <b-form-spinbutton id="sb-inline" v-model="value" inline></b-form-spinbutton>
  </div>
</template>

<script>
export default {
  name: "SpinButtons",
  data() {
    return {
      value: 50
    }
  }
}
</script>

<style scoped>

</style>
